var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDermatology(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "dermatology"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_46",
    d: "M68,3l0,62c0,1.656 -1.344,3 -3,3l-62,0c-1.656,0 -3,-1.344 -3,-3l0,-62c0,-1.656 1.344,-3 3,-3l62,0c1.656,0 3,1.344 3,3Z",
    style: {
      fill: "#fff",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.001,
    y: 5,
    width: 39.966,
    height: 58.517
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M49.339,9.752c-1.19,1.508 -2.012,3.273 -2.4,5.155c-0.29,2.045 -0.465,4.104 -0.524,6.169c0,3.793 5.789,12.255 5.789,12.255c0.9,1.626 0.824,3.1 -1.412,3.794c-0.478,0.148 -1.739,0.4 -1.739,0.4c0,0 -2.746,1.249 -1.124,2.8c0.388,0.365 0.609,0.875 0.609,1.407c-0,0.637 -0.314,1.233 -0.839,1.593c-0.664,0.454 -2.04,0.444 -3.076,1.589",
    style: {
      fill: "#fff",
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M49.339,9.752c-1.19,1.508 -2.012,3.273 -2.4,5.155c-0.29,2.045 -0.465,4.104 -0.524,6.169c0,3.793 5.789,12.255 5.789,12.255c0.9,1.626 0.824,3.1 -1.412,3.794c-0.478,0.148 -1.739,0.4 -1.739,0.4c0,0 -2.746,1.249 -1.124,2.8c0.388,0.365 0.609,0.875 0.609,1.407c-0,0.637 -0.314,1.233 -0.839,1.593c-0.664,0.454 -2.04,0.444 -3.076,1.589",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M47.765,43.377c0.485,0.593 0.755,1.334 0.764,2.1c-0,1.26 -1.841,1.832 -1.841,2.519c0.134,1.53 0.056,3.072 -0.23,4.581c-0.46,1.718 -2.993,3.664 -6.446,2.863c-3.453,-0.801 -10.243,-2.176 -10.243,-2.176",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M23.899,28.075c3.512,-0.286 6.961,-1.095 10.234,-2.4c5.107,-2.344 11.971,-6.338 12.788,-10.773",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M50.831,5.63c-0,0 3.341,3.206 2.3,7.329c-1.041,4.123 -3.8,5.382 -3.8,5.382",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M35.237,54.657c-0,-0 -2.705,2.619 -0.633,8.23",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M24.244,30.273c-0.364,-3.249 -2.039,-6.371 -5.844,-5.845c-2.852,0.394 -4.157,2.7 -3.67,5.932c0.3,1.957 1.282,3.21 1.672,4.7c0.59,2.25 1.154,3.522 2.95,3.522c1.869,-0 2.422,-1.166 3.3,-2.629",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M21.401,30.378c-0,0 -0.421,-3.457 -2.738,-2.828c-2.317,0.629 -0.948,3.143 -0.948,3.143",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M27.124,22.578c10.474,-1.374 12.431,-11.451 12.431,-11.451",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "123.11,24.62,0,24.62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M35.525,7.806c-0,0 -1.957,10.077 -12.431,11.451",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "123.11,24.62,0,24.62"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M32.244,40.044c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M29.217,42.52c0,-0.001 0,-0.001 0,-0.002c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M29.217,37.702c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M39.725,44.51c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M40.302,40.044c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M33.165,44.854c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M30.057,48.06c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M36.698,46.986c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M36.698,42.168c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    d: "M35.663,37.702c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M32.555,34.839c0,-0.002 0,-0.003 0,-0.005c0,-0.59 -0.486,-1.076 -1.076,-1.076c-0.59,0 -1.076,0.486 -1.076,1.076c0,0.59 0.486,1.076 1.076,1.076c0.589,0.001 1.074,-0.482 1.076,-1.071",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDermatology);
export default __webpack_public_path__ + "static/media/dermatology.12f2a4910a5761d9580b0ec073e8487f.svg";
export { ForwardRef as ReactComponent };